
export async function handleResendEmailsService(alreadySentEmailsList, token, setIsMailLoading, setIsResendModalOpen, toast, global, refetchPendingInvitesCount, handleCloseResendModal, setComponentError) {

        try {
                setIsMailLoading(true);
                const response = await fetch("/api/resend-invitations", {
                        method: "POST",
                        headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                                emails: alreadySentEmailsList,
                        }),
                });
                if (response.ok) {
                        setIsResendModalOpen(false);
                        toast.success("Invitations resent successfully!", {
                                position: "bottom-right",
                                autoClose: 2000,
                        });
                        global.config?.activityLog?.(
                                window.location.href,
                                "User Invite",
                                `Invitation successfully resent to ${alreadySentEmailsList}`
                        );
                } else {
                        toast.error("Failed to resend invitations.", {
                                position: "bottom-right",
                                autoClose: 2000,
                        });
                }
        } catch (error) {
                setComponentError(error);
                toast.error("Failed to resend invitations.", {
                        position: "bottom-right",
                        autoClose: 2000,
                });
                console.error(error);
                global.config?.slackMessage?.(error.toString?.());
        } finally {
                setIsMailLoading(false);
                refetchPendingInvitesCount();
                handleCloseResendModal();
        }


}


export const handleSubmitService = async ({ handleOpenResendModal, dispatch, setNotification, setAlreadySentEmailsList, setIsModalOpen, email, userType, emails, setEmail, setEmails, setEmailValodation, setSelectValodation, toast, handleCloseModal, refetchPendingInvitesCount, setIsMailLoading, setComponentError, token }) => {


        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmails = emails.every(
                (obj) => !obj.email || emailRegex.test(obj.email)
        );
        if (email === "") {
                setEmailValodation(true);
                toast.error("Email is required!", { position: "bottom-right", autoClose: 2000 });
                return;
        } else {
                setEmailValodation(false);
        }
        if (userType === "") {
                setSelectValodation(true);
                toast.error("Role is required!", { position: "bottom-right", autoClose: 2000 });
                return;
        } else {
                setSelectValodation(false);
        }
        if (!isValidEmails) {
                toast.error("Please enter valid email addresses!!", {
                        position: "bottom-right",
                        autoClose: 2000,
                });
                handleCloseModal();
                return;
        }
        var allEmails = emails;
        if (email !== "") {
                allEmails = [
                        ...emails,
                        { email: email, id: Date.now(), userType: userType },
                ];
        }
        if (!email || !userType) {
                toast.error("Email and user type cannot be empty!", {
                        position: "bottom-right",
                        autoClose: 2000,
                });
                return;
        }
        if (allEmails.some((obj) => !obj.email || !obj.userType)) {
                toast.error("Email and user type cannot be empty!", {
                        position: "bottom-right",
                        autoClose: 2000,
                });
                return;
        }
        try {
                setIsMailLoading(true);
                const response = await fetch("/api/user-invite", {
                        method: "POST",
                        headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                                emails: allEmails.map((obj) => ({
                                        email: obj.email,
                                        userType: obj.userType,
                                })),
                                invite_status: "0",
                        }),
                });
                const data = await response.json();
                setEmails([]);
                setEmail("");
                setIsModalOpen(false);
                if (response.ok) {
                        if (
                                data.alreadySentEmails.length > 0 ||
                                data.alreadyRegisteredEmails.length > 0
                        ) {
                                const alreadySentEmails = data.alreadySentEmails.join(", ");
                                const alreadyRegisteredEmails =
                                        data.alreadyRegisteredEmails.join(", ");
                                const successSentEmails = data.successSentEmails.join(", ");

                                if (alreadySentEmails) {
                                        setAlreadySentEmailsList(data.alreadySentEmails);
                                        const sentEmailsList = data.alreadySentEmails
                                                .map((entry) => entry.email)
                                                .join(", ");
                                        handleOpenResendModal();
                                        toast.success(`Invitation already sent to ${sentEmailsList}`, {
                                                position: "bottom-right",
                                                autoClose: 1500,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true,
                                                progress: undefined,
                                        });
                                }

                                if (alreadyRegisteredEmails) {
                                        toast.warning(
                                                `User with email ${alreadyRegisteredEmails} is already registered`,
                                                {
                                                        position: "bottom-right",
                                                        autoClose: 1500,
                                                        hideProgressBar: false,
                                                        closeOnClick: true,
                                                        pauseOnHover: true,
                                                        draggable: true,
                                                        progress: undefined,
                                                }
                                        );
                                }

                                if (successSentEmails) {
                                        dispatch(setNotification(Date.now()));
                                        toast.success(
                                                `Invitation successfully sent to ${successSentEmails}`,
                                                {
                                                        position: "bottom-right",
                                                        autoClose: 2000,
                                                        hideProgressBar: false,
                                                        closeOnClick: true,
                                                        pauseOnHover: true,
                                                        draggable: true,
                                                        progress: undefined,
                                                }
                                        );
                                        global.config.activityLog(
                                                window.location.href,
                                                "User Invite",
                                                `Invitation successfully sent to ${successSentEmails}`
                                        );
                                }
                        } else {
                                const successSentEmails = data.successSentEmails.join(", ");
                                dispatch(setNotification(Date.now()));
                                toast.success("Mail sent successfully!", {
                                        position: "bottom-right",
                                        autoClose: 2000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                });
                                global.config.activityLog(
                                        window.location.href,
                                        "User Invite",
                                        `Invitation successfully sent to ${successSentEmails}`
                                );
                        }
                } else {
                        toast.error("Failed to send mail.", {
                                position: "bottom-right",
                                autoClose: 1500,
                        });
                }
        } catch (error) {
                setComponentError(error);
                toast.error("Something went wrong while sending invite.", {
                        position: "bottom-right",
                        autoClose: 2000,
                });
                console.error(error);
                global.config?.slackMessage?.(error.toString?.());
        } finally {
                setIsMailLoading(false);
                refetchPendingInvitesCount();
                handleCloseModal();
        }

}


export const exportToExcel = async (filteredData, userCategory, moment, XLSX) => {

        try {
                const now = new Date();
                const formattedDate =
                        now.getFullYear() +
                        "-" +
                        (now.getMonth() + 1).toString().padStart(2, "0") +
                        "-" +
                        now.getDate().toString().padStart(2, "0");
                const formattedTime =
                        now.getHours().toString().padStart(2, "0") +
                        ":" +
                        now.getMinutes().toString().padStart(2, "0") +
                        ":" +
                        now.getSeconds().toString().padStart(2, "0");

                const modifiedLog = filteredData.map((item, index) => ({
                        SlNo: index + 1,
                        "User Name": item.first_name
                                ? `${item.first_name} ${item.middle_name && item.middle_name !== "null"
                                        ? item.middle_name + " "
                                        : ""
                                }${item.last_name}`
                                : item.company_first_name
                                        ? `${item.company_first_name} ${item.company_last_name || ""}`
                                        : `${item.company_name || ""} (Company)`,
                        Email: item.email,
                        "Company Name": item.company_name,
                        "User Category":
                                item.user_category === userCategory.Individual
                                        ? "Individual"
                                        : item.user_category === userCategory.Business
                                                ? "Business"
                                                : item.user_category === userCategory.Vendor
                                                        ? "Vendor"
                                                        : item.user_category === userCategory.Client
                                                                ? "Client"
                                                                : "",
                        Company: item?.user_wx_comapny?.wx_company
                                ? item.user_wx_comapny.wx_company
                                : "",
                        Role: item.role_id?.user_type,
                        "Job Title": item.job_title,
                        Department: item?.department?.user_department,
                        "Date of Birth": item?.dob
                                ? moment(item.dob)
                                        .tz(global.config.getTimeZone())
                                        .format("DD/MM/YYYY")
                                : "",
                        "Passport Number": item.passport_no,
                        "Registration Number": item.register_number,
                        Mobile: item.mobile_no,
                        Address: item.address,
                        Pincode: item.pincode,
                        Country: item.country,
                        State: item.state,
                        City: item.city,
                        Currency: item.payment_currency,
                        "Type of contract": item.typeOfContract
                                ? item.typeOfContract.typeOfContract
                                : " ",
                        "Monthly Hours": `${item.monthly_hours || 168} hrs`,
                        Compensation: item.cost
                                ? item.cost.toLocaleString("en-US", {
                                        style: "currency",
                                        currency: item.payment_currency || "USD",
                                })
                                : new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: item.payment_currency || "USD",
                                }).format(0),
                        "Overhead Cost per Hour": item.overhead_cost
                                ? item.overhead_cost.toLocaleString("en-US", {
                                        style: "currency",
                                        currency: item.payment_currency || "USD",
                                })
                                : new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: item.payment_currency || "USD",
                                }).format(0),
                        "VAT (%)": `${item.vat} %`,
                        "Vat Id": item.vat_number ? item.vat_number : " ",
                        "Is Client Active": item.is_active ? "Yes" : "No",
                        "Created at": moment(parseInt(item.created_at)).format(
                                "DD/MM/YYYY, hh:mm:ss A"
                        ),
                }));

                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(modifiedLog);

                // Calculate column widths based on the maximum length of the data in each column
                const getMaxLength = (arr, field) =>
                        Math.max(
                                ...arr.map((item) => (item[field] || "").toString().length),
                                field.length
                        );

                const headers = Object.keys(modifiedLog[0]);
                const colWidths = headers.map((header) => ({
                        wch: getMaxLength(modifiedLog, header) + 5, // Add padding to each column
                }));

                worksheet["!cols"] = colWidths;

                // Add alignment and font styling for header
                const firstRow = XLSX.utils.decode_range(worksheet["!ref"]).s.r;
                for (let i = 0; i < headers.length; i++) {
                        const cell = XLSX.utils.encode_cell({ r: firstRow, c: i });
                        const style = worksheet[cell]?.s || {};
                        style.alignment = style.alignment || {};
                        style.alignment.horizontal = "center";
                        style.alignment.vertical = "center";
                        style.font = { size: 14, bold: true };
                        worksheet[cell] = { ...worksheet[cell], s: style };
                }

                // Set border for active area and increase font size for data
                const range = XLSX.utils.decode_range(worksheet["!ref"]);
                for (let row = range.s.r + 1; row <= range.e.r; row++) {
                        for (let col = range.s.c; col <= range.e.c; col++) {
                                const cell = XLSX.utils.encode_cell({ r: row, c: col });
                                const style = worksheet[cell]?.s || {};
                                style.font = { size: 12 };
                                worksheet[cell] = { ...worksheet[cell], s: style };
                        }
                }

                const fileName = `Users_${formattedDate}_${formattedTime}.xlsx`;
                worksheet["!autofilter"] = { ref: range };
                XLSX.utils.book_append_sheet(workbook, worksheet, "Clients Log");
                XLSX.writeFile(workbook, fileName);
        } catch (error) {
                console.log(error);
                global.config.slackMessage(error.toString());
                global.config.activityLog(
                        window.location.href,
                        "Clients Log",
                        "Error occurred while exporting to Excel"
                );
                alert("Error occurred while exporting to Excel.");
        }


}